import { ManagedAgentResponseModel } from '@/customApiClients/mgmtApiClient/Api';

import { AgentDetailRow } from '@/components/agents/AgentDetailRow';
import { AgentToolsCell } from '@/components/agents/AgentToolsCell';
import { AgentAvatar } from '@/components/chat/MessageComposer/AgentAvatar';
import { AgentSourcesBadges } from '@/components/chat/MessageComposer/AgentBadges/AgentSourcesBadges';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';
import { MarkdownContent } from '@/components/ui/markdown-content';
import { Separator } from '@/components/ui/separator';

import { AgentInformation } from '@/hooks/useAgentInformation';

interface AgentDetailDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    agent: ManagedAgentResponseModel;
    information: AgentInformation;
    animateAvatar?: boolean;
}


export function AgentDetailDialog({
    open,
    onOpenChange,
    agent,
    information,
    animateAvatar
}: AgentDetailDialogProps) {
    const {
        loading,
        description,
        mcpServerNames,
        hasInternetAccess,
        hasCodeWriteAccess
    } = information;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="flex flex-col gap-0 p-0 max-w-xl max-h-[80vh]">
                <DialogHeader className="flex-row items-center gap-3 px-6 pt-6 pr-12 pb-4">
                    <AgentAvatar
                        agentId={agent.agentId}
                        className="size-8 shrink-0"
                        animate={animateAvatar}
                    />
                    <div className="flex-1 min-w-0">
                        <DialogTitle className="truncate">
                            {agent.displayName}
                        </DialogTitle>
                        <DialogDescription>
                            Agent
                        </DialogDescription>
                    </div>
                </DialogHeader>

                <Separator />

                <div className="flex-1 px-6 overflow-y-auto custom-scrollbar">
                    <AgentDetailRow label="About">
                        <MarkdownContent className="text-secondary-foreground text-sm">
                            {description}
                        </MarkdownContent>
                    </AgentDetailRow>

                    <AgentDetailRow label="Tools" alignToBadges>
                        <AgentToolsCell
                            loading={loading}
                            hasInternetAccess={hasInternetAccess}
                            hasCodeWriteAccess={hasCodeWriteAccess}
                            enableRls={agent.enableRls}
                        />
                    </AgentDetailRow>

                    <AgentDetailRow label="Sources" alignToBadges>
                        <AgentSourcesBadges
                            loading={loading}
                            mcpServerNames={mcpServerNames}
                        />
                    </AgentDetailRow>
                </div>

                <Separator />

                <DialogFooter className="items-center px-6 py-4">
                    <Button size="medium" variant="ghost" onClick={() => onOpenChange(false)}>
                        Close
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
